export default __webpack_public_path__ + "images/save-file-disabled.svg";